<template>
  <div class="hms-disinfection">
    <div class="header">
      <a-breadcrumb style="margin-bottom: 20px">
        <a-breadcrumb-item>健康系统</a-breadcrumb-item>
        <a-breadcrumb-item>消杀上传记录</a-breadcrumb-item>
      </a-breadcrumb>

      <a-row>
        <a-col :span="18">
          <a-select
            default-value="createTime"
            style="width: 150px; margin-right: 10px"
            @change="handleQueryTypeSelectOptionChange"
          >
            <a-select-option value="createTime"> 上传时间 </a-select-option>
          </a-select>
          <a-range-picker
            @change="
              (date, dateString) => {
                this.queryDate = dateString;
              }
            "
          />
          <a-button
            type="primary"
            icon="search"
            style="margin-left: 10px"
            @click="handleQueryDateBtnClick"
            >查询</a-button
          >
          <!-- <a-button
            type="default"
            icon="export"
            style="margin-left: 10px"
            :disabled="dataSourceList.length === 0"
            @click="dataExportFormModalVisible = true"
            >数据导出</a-button
          > -->
        </a-col>
        <a-col :span="6">
          <a-input-search
            v-model="dataSourceSearchInput"
            placeholder="请输入任何想搜索的内容"
            allowClear
            @search="handleDataSourceSearch"
          />
        </a-col>
      </a-row>
    </div>
    <div class="body">
      <a-table
        rowKey="id"
        :data-source="getCurrentDataSourceList"
        :pagination="paginationOptions"
        @change="
          (pagination) => {
            paginationOptions.current = pagination.current;
            paginationOptions.pageSize = pagination.pageSize;
          }
        "
        :scroll="{ x: 1200 }"
        bordered
        size="small"
      >
        <a-table-column key="index" title="序号" :width="60" data-index="index" fixed="left">
          <template slot-scope="text, record, index">
            <span>{{
              (paginationOptions.current - 1) * paginationOptions.pageSize +
              parseInt(index) +
              1
            }}</span>
          </template>
        </a-table-column>
        <a-table-column
          key="startTime"
          title="开始时间"
          :width="200"
          data-index="startTime"
        />
        <a-table-column
          key="endTime"
          title="结束时间"
          :width="200"
          data-index="endTime"
        />
        <a-table-column
          key="handler"
          title="处理人"
          :width="100"
          data-index="handler"
        />
        <a-table-column
          key="type"
          title="消杀方式"
          :width="100"
          data-index="type"
        />
        <a-table-column
          key="medicine"
          title="消杀药物"
          :width="100"
          data-index="medicine"
        />
        <a-table-column
          key="target"
          title="消杀对象"
          :width="100"
          data-index="target"
        />
        <a-table-column title="消杀图片" :width="100">
          <template slot-scope="text">
            <a @click="handlePhotosShowBtnClick(text)">查看详情</a>
          </template>
        </a-table-column>
        <a-table-column title="消杀报告" :width="100">
          <template slot-scope="text">
            <a @click="handleReportsShowBtnClick(text)">查看详情</a>
          </template>
        </a-table-column>
        <a-table-column
          key="remark"
          title="备注"
          :width="200"
          data-index="remark"
        />
        <a-table-column
          key="createTime"
          title="创建时间"
          :width="200"
          data-index="createTime"
        />
        <a-table-column
          key="createByName"
          title="创建人"
          :width="200"
          data-index="createByName"
		  fixed="right"
        />
      </a-table>
    </div>
    <div class="footer"></div>

    <!-- 消杀图片查看 -->
    <a-modal
      title="消杀图片"
      :visible="photosModalVisible"
      :footer="null"
      @cancel="photosModalVisible = false"
      closable
    >
      <a-row v-if="photosUrlList.length > 0">
        <a-col :span="8" v-for="(item, index) in photosUrlList" :key="index">
          <a-card hoverable style="width: 100%">
            <img slot="cover" alt="example" :src="item" />
            <a-card-meta title="点击查看原图">
              <template slot="description">
                <a :href="item" target="_blank">{{ item }}</a>
              </template>
            </a-card-meta>
          </a-card>
        </a-col>
      </a-row>
      <div v-else><a-empty /></div>
    </a-modal>

    <!-- 消杀报告查看 -->
    <a-modal
      title="消杀报告"
      :visible="reportsModalVisible"
      :footer="null"
      @cancel="reportsModalVisible = false"
      closable
    >
      <div v-if="photosUrlList.length > 0">
        <div v-for="(item, index) in reportsUrlList" :key="index">
          <div>{{ item }} <a :href="item" target="_blank">查看</a></div>
        </div>
      </div>
      <div v-else><a-empty /></div>
    </a-modal>
  </div>
</template>

<script>
import PaginationOptions from "@/options/pagination.js";
import FiltrationOptions from "@/options/filtration.js";
import HmsDisinfectionApi from "@/api/hms/hms-disinfection.js";
import { mapState } from "vuex";

export default {
  name: "HmsDisinfection",
  data() {
    return {
      paginationOptions: PaginationOptions,
      filtrationOptions: FiltrationOptions,
      queryType: "1",
      queryDate: [],
      dataSourceList: [],
      dataSourceCurrent: {},
      dataSourceSearchInput: "",
      dataSourceSearchList: [],
      dataSourceSearchValid: false,
      photosUrlList: [],
      photosModalVisible: false,
      reportsUrlList: [],
      reportsModalVisible: false,
    };
  },
  computed: {
    ...mapState({
      screenSpec: (state) => state.screenSpec,
    }),
    getCurrentDataSourceList: function () {
      return this.dataSourceSearchValid
        ? this.dataSourceSearchList
        : this.dataSourceList;
    },
  },
  watch: {
    dataSourceSearchInput: function (val) {
      if (val === null || val === "") {
        this.dataSourceSearchList = [];
        this.dataSourceSearchValid = false;
      }
    },
  },
  mounted: function () {},
  methods: {
    fetchCheckinVisitorList: function (startTime, endTime) {
      HmsDisinfectionApi.listByStartTimeAndEndTime(
        startTime + " 00:00:00",
        endTime + " 23:59:59"
      ).then((response) => {
        if (response.status === "SUCCESS") {
          this.dataSourceList = response.body;
          if (this.dataSourceList.length === 0) this.$message.success("无数据");
        } else {
          this.dataSourceList = [];
        }
      });
    },
    handleQueryTypeSelectOptionChange: function (value) {
      const temp = ["createTime"];
      this.queryType = (temp.indexOf(value) + 1).toString();
    },
    handleQueryDateBtnClick: function () {
      if (!this.queryDate || this.queryDate.length === 0) {
        this.$message.error("请先选择日期后再查询！");
        return;
      }
      this.fetchCheckinVisitorList(this.queryDate[0], this.queryDate[1]);
    },
    handleTableChange(pagination) {
      this.paginationOptions.current = pagination.current;
      this.paginationOptions.pageSize = pagination.pageSize;
    },
    handleDataSourceSearch: function (value) {
      if (value === null || value === "") {
        this.dataSourceSearchList = [];
        this.dataSourceSearchValid = false;
        return;
      }
      this.dataSourceSearchList = this.dataSourceList.filter((item) => {
        return JSON.stringify(item).indexOf(value.trim()) !== -1;
      });
      this.dataSourceSearchValid = true;
    },
    handlePhotosShowBtnClick: function (payload) {
      this.photosUrlList = [];
      const temp = JSON.parse(payload.photos);
      temp.forEach((item) => {
        if (item.url) this.photosUrlList.push(item.url);
      });
      this.photosModalVisible = true;
    },
    handleReportsShowBtnClick: function (payload) {
      this.reportsUrlList = [];
      const temp = JSON.parse(payload.reports);
      temp.forEach((item) => {
        if (item.url) this.reportsUrlList.push(item.url);
      });
      this.reportsModalVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  margin-bottom: 20px;
}
</style>
